// ============================================
// VARIANT COLOR SWATCHER
// Works on both desktop and mobile
// ============================================
document.addEventListener('DOMContentLoaded', function() {
  
  // Initialize variant swatchers for all products
  document.addEventListener("click", function(e) {
    let btn = e.target.closest(".product-item__color-variant");
    let arrow = e.target.closest(".product-items-arrow-wrapper");

    if (btn) {
      e.preventDefault();

      const productItem = btn.closest(".product-item");
      if (!productItem) return;

      const variantButtons = productItem.querySelectorAll(".product-item__color-variant");
      const mainProductImage = productItem.querySelector('.product-item__image-wrapper img');

      const index = [...variantButtons].indexOf(btn);


      variantButtons.forEach(b => b.classList.remove("active"));
      btn.classList.add("active");

      const image = btn.getAttribute("data-variant-image");
      if (image && mainProductImage) {
        mainProductImage.src = image;
        mainProductImage.srcset = image;
      }

      const id = btn.getAttribute("data-variant-id");
      const inner = btn.closest('.product-item__inner');
      if (!inner) return;

      const swiperEl = inner.querySelector('.product_item_image.swiper');
      if (!swiperEl || !swiperEl.swiper) return;

      const swiper = swiperEl.swiper;
      const slides = swiperEl.querySelectorAll('.swiper-slide');

      let targetIndex = -1;
      slides.forEach((slide, i) => {
        var variantMedia = slide.getAttribute("data-variants_media");
        if (variantMedia && variantMedia.split(",").includes(id)) {
          targetIndex = i;
        }
      });

      if (targetIndex >= 0) {
        swiper.slideToLoop(targetIndex);
      }
    }

    if (arrow) {
      e.preventDefault();

      const productItem = arrow.closest(".product-item");
      if (!productItem) return;

      const variantButtons = productItem.querySelectorAll(".product-item__color-variant");
      if (!variantButtons.length) return;

      let current;
      variantButtons.forEach((variantButton, index) => {
        if (variantButton.classList.contains('active')) {
          current = index;
        }
      });
      let next = (current + 1) % variantButtons.length;
      let nextBtn = variantButtons[next];

      // nextBtn.click(); 
    }
  });




  // // ============================================
  // // GRID LAYOUT SWITCHER (Mobile Only)
  // // ============================================
  // const layoutSwitcherButtons = document.querySelectorAll('.collection-product-grid-icon .grid-icon');
  // const productGrid = document.querySelector('.bd-main-collection-product-grid .collection__products');

    
  // if (layoutSwitcherButtons.length > 0 && productGrid) {
      
  //   // Load saved layout on page load
  //   const savedLayout = localStorage.getItem('gridLayout') || 'mixed';
  //   productGrid.classList.add('grid-layout-' + savedLayout);

  //   // Set active icon based on saved layout
  //   const savedIcon = document.querySelector('.grid-icon[data-layout-type="' + savedLayout + '"]');
  //   if (savedIcon) {
  //     savedIcon.classList.add('active');
  //   }

  //   console.log('productGrid :' + productGrid );
  //   // Add click handler to each layout icon
  //   layoutSwitcherButtons.forEach(function(icon) {
  //     icon.addEventListener('click', function() {
  //       const layoutType = this.getAttribute('data-layout-type');
        
  //       // Remove all layout classes
  //       productGrid.classList.remove('grid-layout-mixed', 'grid-layout-two-col', 'grid-layout-one-col');
        
  //       // Add selected layout class
  //       if (layoutType) {
  //         productGrid.classList.add('grid-layout-' + layoutType);
  //         localStorage.setItem('gridLayout', layoutType); // Save to localStorage
  //       }
        
  //       // Update active state on icons
  //       layoutSwitcherButtons.forEach(btn => btn.classList.remove('active'));
  //       this.classList.add('active');
  //     });
  //   });

  // }
  // // Sync grid icons on click & load
  // document.addEventListener('click', function(e) {
  //   const icon = e.target.closest('.grid-icon');
  //   if (icon) {
  //     const type = icon.getAttribute('data-layout-type');
  //     document.querySelectorAll('.grid-icon').forEach(i => i.classList.remove('active'));
  //     document.querySelectorAll('.grid-icon[data-layout-type="' + type + '"]').forEach(i => i.classList.add('active'));
  //   }
  // });
  
  // // Load saved state
  // const saved = localStorage.getItem('gridLayout') || 'mixed';
  // document.querySelectorAll('.grid-icon[data-layout-type="' + saved + '"]').forEach(i => i.classList.add('active'));

  // ============================================
  // GRID LAYOUT SWITCHER (Mobile Only) - MutationObserver + Delegation
  // ============================================

  // Helper: get current product grid (may return null)
  const getProductGrid = () => document.querySelector('.bd-main-collection-product-grid .collection__products');

  // Apply layout class to a grid element
  const applyLayoutToGrid = (gridEl, layoutType) => {
    if (!gridEl) return;
    gridEl.classList.remove('grid-layout-mixed', 'grid-layout-two-col', 'grid-layout-one-col');
    gridEl.classList.add('grid-layout-' + layoutType);
  };

  // Read saved layout
  const savedLayout = localStorage.getItem('gridLayout') || 'mixed';

  // Initial apply if grid exists now
  const initialGrid = getProductGrid();
  if (initialGrid) {
    applyLayoutToGrid(initialGrid, savedLayout);
  }

  // Make icons reflect saved state (safe even if icons appear later)
  const setActiveIconByType = (type) => {
    document.querySelectorAll('.grid-icon').forEach(i => i.classList.remove('active'));
    document.querySelectorAll('.grid-icon[data-layout-type="' + type + '"]').forEach(i => i.classList.add('active'));
  };
  setActiveIconByType(savedLayout);

  // Use event delegation for clicks on layout icons — always queries the current grid
  document.addEventListener('click', function (e) {
    const icon = e.target.closest('.grid-icon');
    if (!icon) return;

    const layoutType = icon.getAttribute('data-layout-type');
    if (!layoutType) return;

    // Always fetch fresh grid (it might have been replaced)
    const productGrid = getProductGrid();
    applyLayoutToGrid(productGrid, layoutType);

    // Persist and sync icons
    localStorage.setItem('gridLayout', layoutType);
    setActiveIconByType(layoutType);
  });

  // Keep icons in sync if some other code toggles one of them programmatically
  document.addEventListener('click', function (e) {
    const icon = e.target.closest('.grid-icon');
    if (!icon) return;
    const type = icon.getAttribute('data-layout-type');
    document.querySelectorAll('.grid-icon').forEach(i => i.classList.remove('active'));
    document.querySelectorAll('.grid-icon[data-layout-type="' + type + '"]').forEach(i => i.classList.add('active'));
  });

  // ------- MutationObserver: watch for replacement/insertion of product grid -------
  // Choose a stable parent to observe. Prefer the wrapper; fallback to body.
  const wrapper = document.querySelector('.bd-main-collection-product-grid') || document.body;

  let lastSeenGrid = initialGrid;

  // Function to run when grid appears/changes
  const handleGridChange = (gridEl) => {
    if (!gridEl) return;
    // if it's the same element reference, nothing to do
    if (gridEl === lastSeenGrid) return;
    lastSeenGrid = gridEl;

    // Apply saved layout (so newly injected grid respects user's choice)
    const layoutToApply = localStorage.getItem('gridLayout') || 'mixed';
    applyLayoutToGrid(gridEl, layoutToApply);

    // Optionally, run any initialization logic you need for the grid here
    // console.log('Grid replaced/inserted — applied layout:', layoutToApply);
  };

  // Observe child additions/removals anywhere inside wrapper
  const observer = new MutationObserver((mutations) => {
    // On any mutation, try to find the product grid and handle it
    // Minimal work per mutation to avoid heavy loops
    const grid = getProductGrid();
    if (grid) handleGridChange(grid);
  });

  // Observe childList & subtree changes so we catch replacements and inner HTML swaps
  observer.observe(wrapper, { childList: true, subtree: true });

  // Also protect against the edge-case where wrapper itself is replaced:
  // observe document.body for the wrapper being re-inserted (cheap check, low frequency)
  if (wrapper !== document.body) {
    const bodyObserver = new MutationObserver(() => {
      const newWrapper = document.querySelector('.bd-main-collection-product-grid') || null;
      if (newWrapper && newWrapper !== wrapper) {
        // Re-run a grid detection — handleGridChange will be called by the other observer when needed
        const grid = getProductGrid();
        if (grid) handleGridChange(grid);
      }
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }

  
  // Smooth filter toggle
  const bottomFilter = document.querySelector('.bd-main-collection-product-grid .collection__filters');
  const topFilter = document.querySelector('.mobile-filters.mobile-filter-stick-top');
  
  if (bottomFilter && topFilter) {
    // Hide on load
    bottomFilter.classList.add('hide-filter');

    // Run scroll listener
    window.addEventListener('scroll', toggleFilter, { passive: true });
  }

  function toggleFilter() {
    const rect = topFilter.getBoundingClientRect();
    const visible = rect.top < window.innerHeight && rect.bottom > 0;

    // If top filter is visible → hide bottom
    bottomFilter.classList.toggle('hide-filter', visible);

    // If top filter is NOT visible → show bottom
    bottomFilter.classList.toggle('show-filter', !visible);
  }
});
